import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[upsInputRef]',
  standalone: false,
})
export class InputRefDirective {
  constructor(public element: ElementRef) {}
}
